<template>
  <div class="notifications-container">
    <!-- Vue3 Toastify will render notifications here -->
  </div>
</template>

<script setup>
// This component serves as a placeholder for toast notifications
// The actual notifications are handled by vue3-toastify
</script>

<style>
/* Custom styles for vue3-toastify */
:root {
  --toastify-color-light: #fff;
  --toastify-color-dark: #121212;
  --toastify-color-info: #3b82f6;
  --toastify-color-success: #10b981;
  --toastify-color-warning: #f59e0b;
  --toastify-color-error: #ef4444;
  --toastify-color-transparent: rgba(255, 255, 255, 0.7);
  --toastify-icon-color-info: var(--toastify-color-info);
  --toastify-icon-color-success: var(--toastify-color-success);
  --toastify-icon-color-warning: var(--toastify-color-warning);
  --toastify-icon-color-error: var(--toastify-color-error);
  --toastify-container-width: 100%;
  --toastify-toast-width: 320px;
  --toastify-toast-background: #fff;
  --toastify-toast-min-height: 64px;
  --toastify-toast-max-height: 800px;
  --toastify-font-family: 'Inter', sans-serif;
  --toastify-z-index: 9999;
}

.Vue-Toastification__container {
  @apply z-50;
}

.Vue-Toastification__toast {
  @apply shadow-lg rounded-lg border;
}

.Vue-Toastification__toast--success {
  @apply border-green-200 bg-green-50;
}

.Vue-Toastification__toast--error {
  @apply border-red-200 bg-red-50;
}

.Vue-Toastification__toast--warning {
  @apply border-yellow-200 bg-yellow-50;
}

.Vue-Toastification__toast--info {
  @apply border-blue-200 bg-blue-50;
}
</style>